export default "__VITE_PUBLIC_ASSET__e44a3233__"